import Vue from "vue";
import SvgIcon from '@/components/SvgIcon'// svg component
import LineChart from '@/components/LineChart'// svg component

// register globally
Vue.component('svg-icon', SvgIcon)
Vue.component('line-chart', LineChart)

const req = require.context('./svg', false, /\.svg$/)
const requireAll = requireContext => requireContext.keys().map(requireContext)
requireAll(req)
